import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from 'recharts';

const COLORS = ['#9754e3', '#b07ce8', '#7c3aed', '#a78bfa', '#c4b5fd', '#6d28d9', '#ddd6fe'];

const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
        return (
            <div style={{
                background: 'rgba(20, 20, 20, 0.95)',
                border: '1px solid rgba(151, 84, 227, 0.4)',
                borderRadius: '8px',
                padding: '10px 14px',
                backdropFilter: 'blur(10px)'
            }}>
                <p className='fl cw fs12' style={{ marginBottom: 4 }}>{label}</p>
                <p className='fb cw'>{payload[0].value}%</p>
            </div>
        );
    }
    return null;
};

const ReChartBar = ({ label, data }) => {
    return (
        <div className='df fdc'>
            <p className='fb cs fs12 mb1' style={{ textTransform: 'uppercase', letterSpacing: '0.1em' }}>{label}</p>
            <div style={{ width: '100%', height: '220px' }}>
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={data} barSize={24} margin={{ top: 5, right: 10, left: -15, bottom: 5 }}>
                        <XAxis
                            dataKey="name"
                            axisLine={false}
                            tickLine={false}
                            tick={{ fill: 'rgba(255,255,255,0.5)', fontSize: 11, fontFamily: 'r' }}
                        />
                        <YAxis
                            axisLine={false}
                            tickLine={false}
                            tick={{ fill: 'rgba(255,255,255,0.3)', fontSize: 11, fontFamily: 'r' }}
                        />
                        <Tooltip content={<CustomTooltip />} cursor={{ fill: 'rgba(151, 84, 227, 0.08)' }} />
                        <Bar dataKey="value" radius={[6, 6, 0, 0]}>
                            {data?.map((_, index) => (
                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                            ))}
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

export default ReChartBar;
